// Spelverket product page behaviour:
// - keeps custom variant-dependent markup ([data-variant-sync]) in sync when the variant changes
// - restores the add-to-cart label (e.g. "Förbeställ") that Dawn resets on variant change
// - mobile sticky add-to-cart bar that proxies the main product form
// - "Visa hela texten" description toggle

if (!window.spelverketVariantSyncSubscribed && typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
  window.spelverketVariantSyncSubscribed = true;

  subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
    if (!data || !data.html) return;
    const { html, sectionId } = data;

    document.querySelectorAll('product-info').forEach((productInfo) => {
      const productInfoSectionId = productInfo.dataset.originalSection || productInfo.dataset.section;
      if (productInfoSectionId !== sectionId) return;

      productInfo.querySelectorAll('[data-variant-sync]').forEach((destination) => {
        const source = html.querySelector(`[data-variant-sync="${destination.dataset.variantSync}"]`);
        if (source) destination.innerHTML = source.innerHTML;
      });

      productInfo.querySelectorAll('[data-variant-sync-hidden]').forEach((destination) => {
        const source = html.querySelector(`[data-variant-sync-hidden="${destination.dataset.variantSyncHidden}"]`);
        if (source) destination.hidden = source.hasAttribute('hidden');
      });

      const sourceButton = html.getElementById(`ProductSubmitButton-${sectionId}`);
      // The main add-to-cart button (add-on lists further down also contain product forms).
      const button = productInfo.querySelector('product-form [id^="ProductSubmitButton-"]');
      if (sourceButton && button) {
        const sourceLabel = sourceButton.querySelector('span');
        const label = button.querySelector('span');
        if (sourceLabel && label) label.innerHTML = sourceLabel.innerHTML;
        button.classList.toggle('button--preorder', sourceButton.classList.contains('button--preorder'));
      }
    });
  });
}

if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.productInfo = this.closest('product-info');
        if (!this.button || !this.productInfo || this.closest('quick-add-modal')) return;

        this.mainButton = this.productInfo.querySelector(`#ProductSubmitButton-${this.dataset.sectionId}`);
        this.buyButtons = this.productInfo.querySelector('[data-variant-sync-hidden="buy-buttons"]');
        if (!this.mainButton) return;

        this.mainButtonInView = false;
        this.observer = new IntersectionObserver(([entry]) => {
          this.mainButtonInView = entry.isIntersecting;
          this.update();
        });
        this.observer.observe(this.mainButton);

        this.mutationObserver = new MutationObserver(() => this.update());
        this.mutationObserver.observe(this.mainButton, {
          attributes: true,
          attributeFilter: ['class', 'disabled', 'aria-disabled'],
          childList: true,
          subtree: true,
          characterData: true,
        });
        if (this.buyButtons) {
          this.mutationObserver.observe(this.buyButtons, { attributes: true, attributeFilter: ['hidden'] });
        }

        this.update();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.mutationObserver?.disconnect();
      }

      update() {
        const main = this.mainButton;
        const mainLabel = main.querySelector('span');
        const label = this.button.querySelector('span');
        if (mainLabel && label && label.innerHTML !== mainLabel.innerHTML) label.innerHTML = mainLabel.innerHTML;

        this.button.disabled = main.disabled;
        this.button.classList.toggle('button--preorder', main.classList.contains('button--preorder'));
        this.button.classList.toggle('loading', main.classList.contains('loading'));
        this.button.querySelector('.loading__spinner')?.classList.toggle('hidden', !main.classList.contains('loading'));

        const purchasable = !(this.buyButtons && this.buyButtons.hidden) && !main.disabled;
        const visible = purchasable && !this.mainButtonInView;
        this.classList.toggle('is-visible', visible);
        this.toggleAttribute('inert', !visible);
      }
    }
  );
}

function initProductDescriptionToggles(root = document) {
  root.querySelectorAll('.product-description').forEach((description) => {
    if (description.dataset.toggleReady) return;
    const toggle = description.querySelector('.product-description__toggle');
    const content = description.querySelector('.product-description__content');
    if (!toggle || !content) return;
    description.dataset.toggleReady = 'true';

    // Short descriptions fit without truncation, so the toggle isn't needed.
    if (content.scrollHeight <= content.clientHeight + 4) {
      toggle.hidden = true;
      content.classList.add('is-expanded');
      return;
    }

    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      content.classList.toggle('is-expanded', !expanded);
      toggle.querySelector('span').textContent = expanded ? 'Visa hela texten' : 'Visa mindre';
    });
  });
}

initProductDescriptionToggles();
document.addEventListener('shopify:section:load', (event) => initProductDescriptionToggles(event.target));

// Accordions that are open on desktop start closed on phones to keep the page short
function collapseAccordionsOnMobile(root = document) {
  if (!window.matchMedia('(max-width: 749px)').matches) return;
  root.querySelectorAll('details[data-collapse-on-mobile][open]').forEach((details) => {
    if (details.dataset.mobileCollapsed) return;
    details.dataset.mobileCollapsed = 'true';
    details.open = false;
  });
}

collapseAccordionsOnMobile();
document.addEventListener('shopify:section:load', (event) => collapseAccordionsOnMobile(event.target));
